import React from 'react';

import ErrorMessage from 'components/Common/Formik/ErrorMessage/ErrorMessage';
import { ExtraStyleType } from 'components/Common/Formik/FieldCustom/FieldCustom';
import TextFieldCustom from 'components/Common/Formik/TextFieldCustom/TextFieldCustom';
import useCurrentCountry from 'hooks/useCurrentCountry';
import { editDeliveryAddressFormFields } from 'settings/fields/editDeliveryAddress';
import { Field } from 'settings/fields/field';

import styles from './EditDeliveryAddressField.module.scss';

function EditDeliveryAddressFields(): JSX.Element {
  const fields = editDeliveryAddressFormFields;
  const { isFr } = useCurrentCountry();
  const fieldsStructure = {
    street: fields.street,
    ...(isFr && {
      nameComplement: fields.nameComplement,
    }),
    nameAddress: fields.nameAddress,
    saidPlace: fields.saidPlace,
    postcodeCodeGroup: {
      postalCode: fields.postalCode,
      country: fields.country,
    },
    city: fields.city,
  };

  const extraStyle: ExtraStyleType = {
    container: styles.container,
    fieldContainer: styles.fieldContainer,
    label: styles.fieldLabel,
  };

  const extraStylePostalCode: ExtraStyleType = {
    container: styles.containerFieldPostal,
    fieldContainer: styles.fieldContainerPostal,
  };

  const extraStyleCountry: ExtraStyleType = {
    container: styles.containerFieldCountry,
    fieldContainer: styles.fieldContainerPostal,
  };

  return (
    <>
      {Object.entries(fieldsStructure).map(([key, value]) => {
        if (key === 'postcodeCodeGroup') {
          const values = value as Record<string, Field>;

          return (
            <div className={styles.containerPostCode} key={key}>
              <div className={styles.containerLabel}>
                <label>
                  {values.postalCode.label}
                  <span>*</span>
                </label>
              </div>
              <div className={styles.containerFieldError}>
                <div className={styles.containerFields}>
                  <FieldComponent
                    {...values.postalCode}
                    label={undefined}
                    isErrorVisible={false}
                    extraStyle={extraStylePostalCode}
                  />
                  <FieldComponent
                    {...values.country}
                    label={undefined}
                    extraStyle={extraStyleCountry}
                  />
                </div>
                <ErrorMessage
                  name={values.postalCode.name}
                  additionalClass={styles.messageError}
                />
              </div>
            </div>
          );
        }

        return (
          <FieldComponent
            key={key}
            extraStyle={extraStyle}
            {...(value as Field)}
          />
        );
      })}
    </>
  );
}

export default EditDeliveryAddressFields;

const FieldComponent = (
  props: Field & { extraStyle?: ExtraStyleType; isErrorVisible?: boolean }
) => {
  return (
    <TextFieldCustom
      name={props.name}
      label={props.label}
      required={props?.required}
      autoComplete={props?.autoComplete as string}
      extraStyle={props?.extraStyle}
      type={props?.type}
      placeholder={props?.placeholder}
      validation={props?.validation}
      isErrorVisible={props?.isErrorVisible}
      disabled={props?.disabled}
      uppercase={props?.uppercase}
    />
  );
};
